var lib_core      = require("lib-core");
var THREE         = require("three");
var lib_geometry      = require("lib-geometry");
var GlobalRotationModel  = require("./../abstract/globalRotationHandleModel.js");

var GlobalZRotationModel = function (editorModel, handleId, config) {
    GlobalRotationModel.call(this, editorModel, handleId);

    this.axis = new THREE.Vector3(0,0,1);
};

lib_core.inherit(GlobalZRotationModel, GlobalRotationModel);
GlobalZRotationModel.$class = "GlobalZRotationModel";
module.exports = GlobalZRotationModel;

GlobalZRotationModel.prototype.getCurrentAngle = function(position){
    var subject = this.getSubject();
    var basePos = subject.getPosition();

    var vectorToCenter = position.sub(basePos);
    vectorToCenter.normalize();
    return Math.atan2(vectorToCenter.y, vectorToCenter.x);
}
